"use strict";
/**
 * @description 对齐方式
 * @author liuwei
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DropListMenu_1 = __importDefault(require("../menu-constructors/DropListMenu"));
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var Justify = /** @class */ (function (_super) {
    __extends(Justify, _super);
    function Justify(editor) {
        var _this = this;
        var $elem = dom_core_1.default('<div class="w-e-menu"><i class="w-e-icon-paragraph-left"></i></div>');
        var dropListConf = {
            width: 100,
            title: '对齐方式',
            type: 'list',
            list: [
                {
                    $elem: dom_core_1.default("<p>\n                            <i class=\"w-e-icon-paragraph-left w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.justify.靠左') + "\n                        </p>"),
                    value: 'justifyLeft',
                },
                {
                    $elem: dom_core_1.default("<p>\n                            <i class=\"w-e-icon-paragraph-center w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.justify.居中') + "\n                        </p>"),
                    value: 'justifyCenter',
                },
                {
                    $elem: dom_core_1.default("<p>\n                            <i class=\"w-e-icon-paragraph-right w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.justify.靠右') + "\n                        </p>"),
                    value: 'justifyRight',
                },
                {
                    $elem: dom_core_1.default("<p>\n                            <i class=\"w-e-icon-paragraph-justify w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.justify.两端') + "\n                        </p>"),
                    value: 'justifyFull',
                },
            ],
            clickHandler: function (value) {
                // 执行对应的value操作
                _this.command(value);
            },
        };
        _this = _super.call(this, $elem, editor, dropListConf) || this;
        return _this;
    }
    /**
     * 执行命令
     * @param value value
     */
    Justify.prototype.command = function (value) {
        var editor = this.editor;
        var selection = editor.selection;
        var $selectionElem = selection.getSelectionContainerElem();
        // 保存选区
        selection.saveRange();
        // 数据项
        var justifyClass = {
            justifyLeft: 'left',
            justifyCenter: 'center',
            justifyRight: 'right',
            justifyFull: 'justify',
        };
        // 获取顶级元素
        var $elems = editor.selection.getSelectionRangeTopNodes(editor);
        // 选区等于textElem时表示选择了多个段落
        if ($selectionElem && editor.$textElem.equal($selectionElem)) {
            // 获取在css中对应style的值
            var justifyValue_1 = justifyClass[value];
            $elems.forEach(function (el) {
                el.css('text-align', justifyValue_1);
            });
        }
        else {
            // 如果单行的使用execcommand实现
            editor.cmd.do(value, value);
        }
        //恢复选区
        selection.restoreSelection();
    };
    /**
     * 尝试改变菜单激活（高亮）状态
     * 默认左对齐,若选择其他对其方式对active进行高亮否则unActive
     * ?考虑优化的话 是否可以对具体选中的进行高亮
     */
    Justify.prototype.tryChangeActive = function () {
        // const editor = this.editor
        // let isjustify = ['justifyCenter', 'justifyRight'].some(e => editor.cmd.queryCommandState(e))
        // if (isjustify) {
        //     this.active()
        // } else {
        //     this.unActive()
        // }
    };
    return Justify;
}(DropListMenu_1.default));
exports.default = Justify;
